"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var classnames_1 = __importDefault(require("classnames"));
var useClickOutside_1 = __importDefault(require("../../hooks/useClickOutside"));
var styles_1 = require("./styles");
var Switch = function (_a) {
    var checked = _a.checked, disabled = _a.disabled, label = _a.label, secondaryLabel = _a.secondaryLabel, labelPosition = _a.labelPosition, onToggle = _a.onToggle;
    var _b = (0, react_1.useState)(false), isFocused = _b[0], setIsFocused = _b[1];
    var containerRef = (0, react_1.useRef)(null);
    var handleFocus = function () {
        if (!disabled) {
            setIsFocused(true);
        }
    };
    var handleBlur = function () {
        setIsFocused(false);
    };
    var handleClick = function () {
        if (!disabled) {
            onToggle === null || onToggle === void 0 ? void 0 : onToggle();
            setIsFocused(true);
        }
    };
    (0, useClickOutside_1.default)(containerRef, handleBlur);
    // Create a descriptive aria-label
    var ariaLabel = label || secondaryLabel || '';
    return ((0, jsx_runtime_1.jsxs)(styles_1.Container, __assign({ labelPosition: labelPosition, ref: containerRef, onClick: handleClick, className: (0, classnames_1.default)({ disabled: disabled }), "data-testid": "switch-container" }, { children: [secondaryLabel ? ((0, jsx_runtime_1.jsx)(styles_1.SecondaryLabel, __assign({ labelPosition: labelPosition, size: "md" }, { children: secondaryLabel }))) : null, (0, jsx_runtime_1.jsxs)(styles_1.Wrapper, { children: [(0, jsx_runtime_1.jsx)(styles_1.Input, { type: "checkbox", onFocus: handleFocus, onBlur: handleBlur, className: (0, classnames_1.default)({ disabled: disabled }), "data-testid": "switch-input", "aria-label": ariaLabel, "aria-checked": !!checked, "aria-disabled": !!disabled }), (0, jsx_runtime_1.jsx)(styles_1.RoundedSlider, { className: (0, classnames_1.default)({ checked: checked, disabled: disabled, focused: isFocused }) })] }), (0, jsx_runtime_1.jsx)(styles_1.Label, __assign({ labelPosition: labelPosition }, { children: label }))] })));
};
exports.default = Switch;
